<script setup>
// Pastille d'accroche au-dessus d'un titre : pilule pleine, texte blanc, capitales espacées, icône Lucide 14 px.
import { TONES } from '../../lib/brandTones';
defineProps({ tone: { type: String, default: 'maison' } });
</script>

<template>
  <span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" :class="TONES[tone].eyebrow">
    <slot />
  </span>
</template>
